import { create } from 'zustand';

export type MessageType = 'info' | 'error' | 'success' | 'warning';

export interface SecondaryModalState {
  isOpen: boolean;
  content: string;
  modalProps: Record<string, unknown>;
  message: string;
  messageType: MessageType;
  autoDisappear: boolean;
  outerClickDisabled: boolean;
}

export interface SecondaryModalActions {
  show: (content: string, modalProps?: Record<string, unknown>) => void;
  hide: () => void;
  addMessage: (
    message: string,
    opts?: { type?: MessageType; autoDisappear?: boolean },
  ) => void;
  clearMessage: () => void;
}

export type SecondaryModalStore = SecondaryModalState & SecondaryModalActions;

const initialState: SecondaryModalState = {
  isOpen: false,
  content: '',
  modalProps: {},
  message: '',
  messageType: 'info',
  autoDisappear: false,
  outerClickDisabled: false,
};

export const useSecondaryModalStore = create<SecondaryModalStore>((set) => ({
  ...initialState,

  show: (content, modalProps = {}) =>
    set({
      isOpen: true,
      content,
      modalProps,
      message: '',
      messageType: 'info',
      outerClickDisabled: (modalProps.outerClickDisabled as boolean) ?? false,
    }),

  hide: () =>
    set({
      isOpen: false,
      content: '',
      modalProps: {},
      message: '',
      messageType: 'info',
      autoDisappear: false,
    }),

  addMessage: (message, opts = {}) =>
    set({
      message,
      messageType: opts.type ?? 'info',
      autoDisappear: opts.autoDisappear ?? false,
    }),

  clearMessage: () =>
    set({
      message: '',
      messageType: 'info',
      autoDisappear: false,
    }),
}));
